import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import Modal from 'components/Modal';
import { find as _find, findIndex as _findIndex } from 'lodash';

import { injectIntl, FormattedMessage } from 'react-intl';
import AnimateHeight from 'react-animate-height';
import ScrollArea from 'react-scrollbar';

import { getDescriptionInCurrentLanguage } from 'helpers/intl';
import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';
import RichEditorContent from 'components/RichEditorContent';

import Loader from 'components/layout/Loader';
import SepaAgreement from 'components/layout/sepa/SepaAgreement';

import MyParentBankData from 'components/forms/clients/MyParentBankData';

import may from 'js/security';

class PluginActivate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sepaCheckboxChecked: false,
      termsOfUseCheckboxChecked: false,
      showTermsOfUse: false,
      contractCheckboxChecked: false,
      showContract: false,
      orderDataProcessingCheckboxChecked: false,
      showOrderDataProcessing: false,
      useModal: props.useModal,
    };
  }

  // check if current user's company has bank data
  hasBankData = () => {
    const { myParent } = this.props;
    if (!myParent.pending && myParent.data.financial && myParent.data.financial.bank_data) {
      const bankData = myParent.data.financial.bank_data;

      if (bankData.iban && bankData.swift_bic) {
        return true;
      }
    }

    return false;
  };

  hasSepaAgreement = () => {
    const { plugin, sepaAgreements } = this.props;
    if (plugin && !sepaAgreements.pending) {
      return _findIndex(sepaAgreements.data.list, { is_active: true, target: plugin.owner.id }) > -1;
    }

    return false;
  };

  getTermsOfUse = () => {
    const { appIntl, plugin } = this.props;
    const termsOfUseContent = _find(plugin.terms_of_use, ['language', appIntl.displayIntlForm]);
    return termsOfUseContent || {};
  };

  getContract = () => {
    const { appIntl, plugin } = this.props;
    const contractContent = _find(plugin.contract, ['language', appIntl.displayIntlForm]);
    return contractContent || {};
  };

  getOrderDataProcessing = () => {
    const { appIntl, plugin } = this.props;
    const orderDataProcessingContent = _find(plugin.order_data_processing, ['language', appIntl.displayIntlForm]);
    return orderDataProcessingContent || {};
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      show,
      whiteLabelProject,
      plugin,
      sepaAgreementNewFormStatus,
      pluginActivateFormStatus,
      pluginPartialActivateFormStatus,
      pluginRequestActivateFormStatus,
      close,
      doNotify,
    } = this.props;

    if (!prevProps.show && show) {
      this.setState({
        sepaCheckboxChecked: false,
        termsOfUseCheckboxChecked: false,
        showTermsOfUse: false,
        contractCheckboxChecked: false,
        showContract: false,
        orderDataProcessingCheckboxChecked: false,
        showOrderDataProcessing: false,
      });
    }

    // if sepa agreement is sent and if it's successfull, dispatch the plugin activation request
    if (
      prevProps.sepaAgreementNewFormStatus.pending &&
      !sepaAgreementNewFormStatus.pending &&
      !sepaAgreementNewFormStatus.hasError
    ) {
      this.props.submitPluginActivate(whiteLabelProject.id, plugin.id, {});
    }

    // if the plugin is activated, inform the user and close the modal
    if (
      prevProps.pluginActivateFormStatus.pending &&
      !pluginActivateFormStatus.pending &&
      !pluginActivateFormStatus.hasError
    ) {
      doNotify(1, messages.plugin_activated);
      close();
    }

    // if the plugin is partial activated, inform the user and close the modal
    if (
      prevProps.pluginPartialActivateFormStatus.pending &&
      !pluginPartialActivateFormStatus.pending &&
      !pluginPartialActivateFormStatus.hasError
    ) {
      doNotify(1, messages.plugin_partial_activated);
      close();
    }

    // if the plugin activation request was sent, inform the user and close the modal
    if (
      prevProps.pluginRequestActivateFormStatus.pending &&
      !pluginRequestActivateFormStatus.pending &&
      !pluginRequestActivateFormStatus.hasError
    ) {
      doNotify(1, messages.plugin_request_activate_sent);
      close();
    }
  };

  onSubmitActivate = () => {
    // decide what we need to do
    // only activate plugin, or also generate the SEPA agreement ?

    if (!this.hasSepaAgreement()) {
      // when the user has no SEPA agreement yet, we need to create the agreement first
      this.props.submitSepaAgreementNew({ target: { username: this.props.plugin.owner.id } });
    } else {
      // activate the plugin
      this.props.submitPluginActivate(this.props.whiteLabelProject.id, this.props.plugin.id, {});
    }
  };

  onSubmitPartialActivate = () => {
    let data = {};

    if (!this.hasSepaAgreement()) {
      // when the user has no SEPA agreement yet, we need to create the agreement too
      data = { generateSepaAgreement: true };
    }

    // activate the plugin (but only partial)
    this.props.submitPluginPartialActivate(this.props.whiteLabelProject.id, this.props.plugin.id, data);
  };

  onSubmitRequestActivate = () => {
    let data = {};

    if (!this.hasSepaAgreement()) {
      // when the user has no SEPA agreement yet, we need to create the agreement too
      data = { generateSepaAgreement: true };
    }

    this.props.submitPluginRequestActivate(this.props.whiteLabelProject.id, this.props.plugin.id, data);
  };

  close = () => {
    // if the form is pending (sepa or plugin activation), do not close the modal
    if (!this.props.sepaAgreementNewFormStatus.pending && !this.props.pluginActivateFormStatus.pending) {
      this.props.close();
    }
  };

  getTextSubstitute = () => {
    const { intl, plugin, myParent, whiteLabelProject } = this.props;

    let textSubstitute = {
      '%dateToday%': intl.formatDate(new Date(), { year: 'numeric', month: 'numeric', day: 'numeric' }),
      '%ownerCompany%': plugin.owner.company,
      '%ownerAddress%': [
        plugin.owner.street + ' ',
        plugin.owner.house_number + ' ',
        plugin.owner.apartment_number ? plugin.owner.apartment_number : '',
        ', ' + plugin.owner.zip_code + ' ',
        plugin.owner.city,
        ', ' + plugin.owner.country_name,
      ].join(''),
      '%targetCompany%': myParent.data.profile.company,
      '%targetAddress%': [
        myParent.data.profile.street + ' ',
        myParent.data.profile.house_number + ' ',
        myParent.data.profile.apartment_number ? myParent.data.profile.apartment_number : '',
        ', ' + myParent.data.profile.zip_code + ' ',
        myParent.data.profile.city,
        ', ' + myParent.data.profile.country_name,
      ].join(''),
    };

    if (plugin.dependent_on) {
      // check when the main plugin was activated, so we can use the date in the contract
      const masterPlugin = _.find(whiteLabelProject.plugins, ['id', plugin.dependent_on]);
      if (masterPlugin) {
        textSubstitute['%contractFrom%'] = intl.formatDate(masterPlugin.activation_date, {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        });
      }
    }

    return textSubstitute;
  };

  getTermsOfUseCheckbox = () => {
    const {
      intl: { messages },
      plugin,
    } = this.props;
    const { termsOfUseCheckboxChecked } = this.state;

    const pending =
      this.props.sepaAgreementNewFormStatus.pending ||
      this.props.pluginActivateFormStatus.pending ||
      this.props.pluginPartialActivateFormStatus.pending ||
      this.props.pluginRequestActivateFormStatus.pending;

    return (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id="termsOfUseCheckbox"
            name="termsOfUseCheckbox"
            type="checkbox"
            value="true"
            checked={termsOfUseCheckboxChecked}
            onChange={e => this.setState({ termsOfUseCheckboxChecked: e.target.checked })}
          />
          <label for="termsOfUseCheckbox">
            {messages.i_read_and_accept_plugins_terms_of_use}

            {/* if the terms are not shown yet, show a view link */}
            {!this.state.showTermsOfUse && (
              <a href="javascript:;" class="m-l-5" onClick={() => this.setState({ showTermsOfUse: true })}>
                <i className="fas fa-eye" /> {messages.view}
              </a>
            )}
          </label>
        </div>

        {/* container for the plugin's terms of use */}
        <AnimateHeight duration={500} height={this.state.showTermsOfUse ? 'auto' : 0}>
          <ScrollArea
            speed={0.8}
            className=""
            contentClassName=""
            horizontal={false}
            style={{ overflow: 'hidden', height: '300px' }}
          >
            <CmsPage
              data={plugin ? this.getTermsOfUse() : {}}
              doUpdateActiveCms={false}
              doUpdateDocMeta={false}
              textSubstitute={this.getTextSubstitute()}
            />
          </ScrollArea>
        </AnimateHeight>
      </div>
    );
  };

  getContractCheckbox = () => {
    const {
      intl: { messages },
      plugin,
    } = this.props;
    const { contractCheckboxChecked } = this.state;

    const pending =
      this.props.sepaAgreementNewFormStatus.pending ||
      this.props.pluginActivateFormStatus.pending ||
      this.props.pluginPartialActivateFormStatus.pending ||
      this.props.pluginRequestActivateFormStatus.pending;

    return (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id={'contractCheckbox'}
            name="contractCheckbox"
            type="checkbox"
            value={'true'}
            checked={contractCheckboxChecked}
            onChange={e => this.setState({ contractCheckboxChecked: e.target.checked })}
          />
          <label for={'contractCheckbox'}>
            {messages.i_read_and_accept_plugins_contract}

            {/* if the contract is not shown yet, show a view link */}
            {!this.state.showContract ? (
              <a href="javascript:;" class="m-l-5" onClick={() => this.setState({ showContract: true })}>
                <i class="fas fa-eye" /> {messages.view}
              </a>
            ) : null}
          </label>
        </div>

        {/* container for the plugin's contract */}
        <AnimateHeight duration={500} height={this.state.showContract ? 'auto' : 0}>
          <ScrollArea
            speed={0.8}
            className=""
            contentClassName=""
            horizontal={false}
            style={{ overflow: 'hidden', height: '300px' }}
          >
            <CmsPage
              data={plugin ? this.getContract() : {}}
              doUpdateActiveCms={false}
              doUpdateDocMeta={false}
              textSubstitute={this.getTextSubstitute()}
            />
          </ScrollArea>
        </AnimateHeight>
      </div>
    );
  };

  getOrderDataProcessingCheckbox = () => {
    const {
      intl: { messages },
      plugin,
    } = this.props;
    const { orderDataProcessingCheckboxChecked } = this.state;

    const pending =
      this.props.sepaAgreementNewFormStatus.pending ||
      this.props.pluginActivateFormStatus.pending ||
      this.props.pluginPartialActivateFormStatus.pending ||
      this.props.pluginRequestActivateFormStatus.pending;

    return (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id={'orderDataProcessingCheckbox'}
            name="orderDataProcessingCheckbox"
            type="checkbox"
            value={'true'}
            checked={orderDataProcessingCheckboxChecked}
            onChange={e => this.setState({ orderDataProcessingCheckboxChecked: e.target.checked })}
          />
          <label for={'orderDataProcessingCheckbox'}>
            {messages.i_read_and_accept_plugins_order_data_processing}

            {/* if the order data processing is not shown yet, show a view link */}
            {!this.state.showOrderDataProcessing ? (
              <a href="javascript:;" class="m-l-5" onClick={() => this.setState({ showOrderDataProcessing: true })}>
                <i class="fas fa-eye" /> {messages.view}
              </a>
            ) : null}
          </label>
        </div>

        {/* container for the plugin's order data processing */}
        <AnimateHeight duration={500} height={this.state.showOrderDataProcessing ? 'auto' : 0}>
          <ScrollArea
            speed={0.8}
            className=""
            contentClassName=""
            horizontal={false}
            style={{ overflow: 'hidden', height: '300px' }}
          >
            <CmsPage
              data={plugin ? this.getOrderDataProcessing() : {}}
              doUpdateActiveCms={false}
              doUpdateDocMeta={false}
              textSubstitute={this.getTextSubstitute()}
            />
          </ScrollArea>
        </AnimateHeight>
      </div>
    );
  };

  renderContent = () => {
    const {
      intl: { messages },
      appIntl,
      plugin,
      myParent,
      user,
    } = this.props;
    const {
      sepaCheckboxChecked,
      termsOfUseCheckboxChecked,
      contractCheckboxChecked,
      orderDataProcessingCheckboxChecked,
    } = this.state;

    const hasBankData = this.hasBankData();
    const hasSepaAgreement = this.hasSepaAgreement();

    const isAdmin = may('ROLE_ADMIN', user.roles);
    const isSoleRepresentative = may('ROLE_SOLE_REPRESENTATIVE', user.roles);
    const isPartRepresentative = may('ROLE_PART_REPRESENTATIVE', user.roles);

    const pending =
      this.props.sepaAgreementNewFormStatus.pending ||
      this.props.pluginActivateFormStatus.pending ||
      this.props.pluginPartialActivateFormStatus.pending ||
      this.props.pluginRequestActivateFormStatus.pending;

    let submitDisabled = false;
    if (isSoleRepresentative || isPartRepresentative) {
      if (!hasSepaAgreement && !sepaCheckboxChecked) {
        submitDisabled = true;
      }

      if (plugin) {
        if (plugin.terms_of_use_acceptation_needed && !termsOfUseCheckboxChecked) {
          submitDisabled = true;
        } else if (plugin.contract_acceptation_needed && !contractCheckboxChecked) {
          submitDisabled = true;
        } else if (plugin.order_data_processing_acceptation_needed && !orderDataProcessingCheckboxChecked) {
          submitDisabled = true;
        }
      }
    }

    const sepaCheckbox = (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id="sepaCheckbox"
            name="sepaCheckbox"
            type="checkbox"
            value="true"
            checked={sepaCheckboxChecked}
            onChange={e => this.setState({ sepaCheckboxChecked: e.target.checked })}
          />
          <label for="sepaCheckbox">{messages.sepaAgreement.i_issue_sepa_direct_debit_mandate}</label>
        </div>
      </div>
    );

    return (
      <>
        <Data dataName="myParent" url="/api/clients/parent.json" data={myParent} />

        {myParent.pending ? (
          <Loader />
        ) : (
          <div>
            {/* display information about the plugin */}
            <RichEditorContent
              content={'<div>' + (getDescriptionInCurrentLanguage(plugin.description, appIntl) || '') + '</div>'}
            />

            {!hasBankData && !isAdmin && (
              <div class="p-t-20">
                <Alert bsStyle="warning">{messages.missing_companys_bank_data}</Alert>
                <p>
                  <FormattedMessage
                    id="you_can_fill_missing_data_in_settings"
                    values={{
                      settings: <Link to={appIntl.urlPrefix + 'account/settings/myCompany'}>{messages.settings}</Link>,
                    }}
                  />
                </p>
              </div>
            )}

            {!hasBankData && isAdmin && (
              <div className="p-t-20">
                <Alert bsStyle="warning">{messages.missing_companys_bank_data}</Alert>
                <MyParentBankData
                  parent={
                    myParent.data && myParent.data.financial && myParent.data.financial.bank_data
                      ? myParent.data.financial.bank_data
                      : {}
                  }
                />
              </div>
            )}

            {/* the user may decide on the plugin activation on his own */}
            {hasBankData && isSoleRepresentative ? (
              <div className="m-t-20">
                {/* The company has no SEPA agreement, we need to generate one */}
                <SepaAgreement owner={plugin.owner} target={myParent.data} />

                {/* In order to activate the button, user needs to accept the costs and SEPA agreement */}
                {!hasSepaAgreement && sepaCheckbox}

                {plugin.terms_of_use_acceptation_needed && this.getTermsOfUseCheckbox()}
                {plugin.contract_acceptation_needed && this.getContractCheckbox()}
                {plugin.order_data_processing_acceptation_needed && this.getOrderDataProcessingCheckbox()}

                <Button
                  block
                  disabled={submitDisabled || pending}
                  bsStyle={null}
                  bsSize="lg"
                  onClick={this.onSubmitActivate}
                  className="m-t-15"
                >
                  {pending && <i className="fa-fw fa fa-circle-notch fa-spin m-r-5" />}

                  {messages.activate_plugin}
                </Button>
              </div>
            ) : null}

            {/* the user may not decide on the plugin activation on his own and needs one more person to agree */}
            {hasBankData && !isSoleRepresentative && isPartRepresentative && (
              <div className="m-t-20">
                {/* The company has no SEPA agreement, we need to generate one */}
                <SepaAgreement owner={plugin.owner} target={myParent.data} />

                {/* In order to activate the button, user needs to accept the costs and SEPA agreement */}
                {!hasSepaAgreement && sepaCheckbox}

                {plugin.terms_of_use_acceptation_needed && this.getTermsOfUseCheckbox()}
                {plugin.contract_acceptation_needed && this.getContractCheckbox()}
                {plugin.order_data_processing_acceptation_needed && this.getOrderDataProcessingCheckbox()}

                <Alert>{messages.not_sole_representative_click_below_to_request_plugin_activation}</Alert>

                <Button
                  block
                  disabled={submitDisabled || pending}
                  bsStyle={null}
                  bsSize="lg"
                  onClick={this.onSubmitPartialActivate}
                >
                  {pending && <i className="fa-fw fa fa-circle-notch fa-spin m-r-5" />}

                  {messages.partially_activate_plugin}
                </Button>
              </div>
            )}

            {/* the user may not activaty any plugin, but may send a request for representatives to activate the plugin for him */}
            {hasBankData && !isSoleRepresentative && !isPartRepresentative && (
              <div className="m-t-20">
                <Alert>{messages.not_authorized_click_below_to_request_plugin_activation}</Alert>

                <Button block disabled={pending} bsStyle={null} bsSize="lg" onClick={this.onSubmitRequestActivate}>
                  {pending && <i className="fa-fw fa fa-circle-notch fa-spin m-r-5" />}

                  {messages.send_activation_request}
                </Button>
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  render() {
    const {
      intl: { messages },
      show,
      plugin,
      useModal,
    } = this.props;

    if (!useModal) {
      return this.renderContent();
    }

    return plugin ? (
      <Modal show={show} onHide={this.close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.activate_plugin} • {plugin.name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>{this.renderContent()}</Modal.Body>
      </Modal>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    myParent: state.data.myParent,
    sepaAgreements: state.list.sepaAgreements,
    sepaAgreementNewFormStatus: state.formStatus.sepaAgreementNew,
    pluginActivateFormStatus: state.formStatus.pluginActivate,
    pluginPartialActivateFormStatus: state.formStatus.pluginPartialActivate,
    pluginRequestActivateFormStatus: state.formStatus.pluginRequestActivate,
    user: state.login.user,
  };
};
PluginActivate.defaultProps = {
  useModal: true,
  close: () => {},
};

const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    submitSepaAgreementNew: data => {
      formStatusDispatchHelper('sepaAgreementNew', '/api/sepaagreements.json', data, 'post', dispatch);
    },
    submitPluginActivate: (whiteLabelId, pluginId, data) => {
      formStatusDispatchHelper(
        'pluginActivate',
        '/api/whitelabels/' + whiteLabelId + '/plugins/' + pluginId + '/activate.json',
        data,
        'post',
        dispatch
      );
    },
    submitPluginPartialActivate: (whiteLabelId, pluginId, data) => {
      formStatusDispatchHelper(
        'pluginPartialActivate',
        '/api/whitelabels/' + whiteLabelId + '/plugins/' + pluginId + '/partialActivate.json',
        data,
        'post',
        dispatch
      );
    },
    submitPluginRequestActivate: (whiteLabelId, pluginId, data) => {
      formStatusDispatchHelper(
        'pluginRequestActivate',
        '/api/whitelabels/' + whiteLabelId + '/plugins/' + pluginId + '/requestActivate.json',
        data,
        'post',
        dispatch
      );
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PluginActivate)
  )
);
